const es = {
  translation: {
    // Navigation
    'home': 'Inicio',
    'about_us': 'Sobre Nosotros',
    'services': 'Servicios',
    'contact': 'Contacto',
    'locations': 'Ubicaciones',

    // Home page content
    'hero_title': 'Transporte Premium para Tripulaciones Aéreas',
    'hero_title_first_line': 'Transporte Premium',
    'hero_title_second_line': 'para Tripulaciones Aéreas',
    'hero_subtitle': 'Somos el proveedor de transporte número uno en San Francisco, Los Ángeles, Silicon Valley, Florida, Nueva York, Texas y Sídney, Australia.',
    'hero_cta_first_line': 'Hablar con',
    'hero_cta_second_line': 'Concierge de',
    'hero_cta_third_line': 'Transporte',
    'hero_cta': 'Hablar con Nuestro Concierge de Transporte',

    // About section
    'about_title': 'Sobre Nosotros',
    'about_description': 'es el principal proveedor de servicios de transporte para tripulaciones aéreas y hoteles en América del Norte. Durante casi 30 años, hemos estado a la vanguardia proporcionando soluciones de transporte confiables, seguras y eficientes para tripulaciones aéreas en todo el mundo.',
    'about_years': 'Años de Excelencia',
    'about_global_locations': 'Ubicaciones Globales',
    'about_service': 'Servicio y Soporte',
    'get_in_touch': 'Hablar con Nuestro Concierge de Transporte para Tripulaciones Aéreas',
    'about_second_paragraph': 'Nuestra dedicación a la excelencia, puntualidad y satisfacción del cliente nos ha convertido en la opción preferida de numerosas aerolíneas internacionales. Entendemos las necesidades únicas de las tripulaciones de vuelo y hemos adaptado nuestros servicios para garantizar una experiencia cómoda y sin estrés desde la recogida hasta la entrega.',

    // In Good Company section
    'in_good_company_title': 'En Buena Compañía',
    'in_good_company_description': 'Confiado por las principales aerolíneas del mundo para servicios de transporte confiables y premium.',

    // Testimonials section
    'testimonials_title': 'Lo Que Dicen Nuestros Clientes',
    'testimonials_description': 'Descubre por qué las principales aerolíneas y clientes nos eligen para sus necesidades de transporte.',

    // Testimonial quotes
    'testimonial_1_quote': "Me lo pasé muy bien trabajando y finalizando el horario de verano de nuestra tripulación de vuelo con el gerente de Airline Crew Transportation.",
    'testimonial_1_author': "SAS Airlines",
    'testimonial_1_company': "Gerente de Estación",

    'testimonial_2_quote': "Por fin hemos encontrado una JOYA.",
    'testimonial_2_author': "Aish Wedding Services",
    'testimonial_2_company': "CEO y Gerente",

    'testimonial_3_quote': "Fue genial tener una preocupación menos y me sentí tranquilo cuando me recomendaron Airline Crew Transportation para el transporte de nuestra tripulación de vuelo y cabina hacia y desde el hotel.",
    'testimonial_3_author': "El-Al Airlines",
    'testimonial_3_company': "Gerente de Estación",

    // Services section
    'services_title': 'Nuestros Servicios',
    'services_description': 'Explora nuestras opciones de transporte premium, cada una diseñada para satisfacer tus necesidades específicas con comodidad y confiabilidad.',
    'select_a_service': 'Seleccionar un Servicio',
    'get_a_quote': 'Obtener Cotización',

    // Service items
    'service_airport_transfer_title': 'Traslados al Aeropuerto',
    'service_airport_transfer_bullet1': 'Recogidas y entregas puntuales para operaciones fluidas.',
    'service_airport_transfer_bullet2': 'Vehículos limpios y bien equipados para cada viaje.',

    'service_distressed_passengers_title': 'Transporte para Pasajeros Afectados',
    'service_distressed_passengers_bullet1': 'Respuesta rápida 24/7 para retrasos y cancelaciones de vuelos.',
    'service_distressed_passengers_bullet2': 'Reubicación eficiente a hoteles o aeropuertos alternativos.',

    'service_any_occasion_title': 'Servicios de Automóvil para Cualquier Ocasión',
    'service_any_occasion_bullet1': 'Transporte premium para eventos corporativos y reuniones.',
    'service_any_occasion_bullet2': 'Servicio profesional garantizando llegada renovada de ejecutivos.',

    'service_hotel_transfer_title': 'Traslado al Hotel',
    'service_hotel_transfer_bullet1': 'Coordinación perfecta entre alojamientos y aeropuertos.',
    'service_hotel_transfer_bullet2': 'Tiempo perfecto para salidas tempranas y llegadas tardías.',

    'service_flight_cabin_crew_title': 'Transporte para Tripulación de Vuelo y Cabina',
    'service_flight_cabin_crew_bullet1': 'Servicio especializado entendiendo requisitos operativos de aerolíneas.',
    'service_flight_cabin_crew_bullet2': 'Estricto cumplimiento de protocolos de tiempo para horarios de tripulación.',

    'service_company_shuttle_title': 'Servicios de Transporte Corporativo',
    'service_company_shuttle_bullet1': 'Soluciones de transporte personalizadas para empleados y ejecutivos.',
    'service_company_shuttle_bullet2': 'Rutas regulares con seguimiento en tiempo real y eficiencia de costos.',

    'service_charter_services_title': 'Servicios de Chárter',
    'service_charter_services_bullet1': 'Soluciones de transporte personalizadas para grupos de todos los tamaños.',
    'service_charter_services_bullet2': 'Planificación logística profesional con opciones de flota personalizadas.',

    // Fleet section
    'fleet_title': 'Nuestra Flota',
    'fleet_description': 'Descubre nuestra diversa flota de vehículos de lujo, cada uno seleccionado para proporcionar comodidad excepcional, estilo y confiabilidad para todas tus necesidades de transporte.',
    'select_a_vehicle': 'Seleccionar un Vehículo',

    // Fleet items
    'fleet_sedan_title': 'Sedán',
    'fleet_sedan_description': 'Sedanes de lujo para viajes ejecutivos con chóferes profesionales. Hasta 3 asientos.',

    'fleet_suv_title': 'SUV',
    'fleet_suv_description': 'SUVs premium que ofrecen comodidad espaciosa para grupos pequeños. Hasta 6 asientos.',

    'fleet_sprinter_title': 'Sprinter',
    'fleet_sprinter_description': 'Furgonetas Mercedes-Benz Sprinter con comodidades de lujo para grupos de tamaño medio. Hasta 14 asientos.',

    'fleet_minibus_title': 'Minibús',
    'fleet_minibus_description': 'Cómodos minibuses para grupos más grandes con amplio espacio para equipaje. Hasta 27 asientos.',

    'fleet_mini_coach_title': 'Mini Coach',
    'fleet_mini_coach_description': 'Mini coaches que ofrecen transporte premium para grupos medianos a grandes. Hasta 35 asientos.',

    'fleet_coach_title': 'Autocar',
    'fleet_coach_description': 'Autocares de lujo de tamaño completo para necesidades de transporte de grupos grandes. Hasta 55 asientos.',

    // Fleet vehicle details (for carousel)
    'fleet_van_title': 'Furgoneta',
    'fleet_van_capacity': 'Capacidad de Pasajeros 1-3',
    'fleet_van_description': 'Nuestras furgonetas ejecutivas ofrecen una solución cómoda y eficiente para transportar miembros individuales del equipo o pequeños grupos.\n\nCon interiores espaciosos, conductores profesionales y programación confiable, estos vehículos son perfectos para salidas temprano, llegadas tarde y todo lo que esté en el medio.',

    'fleet_sprinter_carousel_title': 'Sprinter',
    'fleet_sprinter_carousel_capacity': 'Capacidad de Pasajeros 1-14',
    'fleet_sprinter_carousel_description': 'Nuestras furgonetas Mercedes Sprinter brindan comodidad premium para grupos de tamaño mediano con amplio espacio para equipaje.\n\nCon asientos de lujo, control climático y chóferes profesionales, estos vehículos son ideales para transferencias de tripulación y necesidades de transporte grupal.',

    'fleet_minivan_title': 'Minifurgoneta',
    'fleet_minivan_capacity': 'Capacidad de Pasajeros 1-7',
    'fleet_minivan_description': 'Nuestras cómodas minifurgonetas son perfectas para grupos pequeños a medianos de tripulación que requieren transporte confiable y eficiente.\n\nCon arreglos de asientos flexibles y espacio de carga generoso, estos vehículos ofrecen el equilibrio perfecto entre comodidad y practicidad para las necesidades de las tripulaciones aéreas.',

    'fleet_minibus_carousel_title': 'Minibús',
    'fleet_minibus_carousel_capacity': 'Capacidad de Pasajeros 1-25',
    'fleet_minibus_carousel_description': 'Nuestros espaciosos minibuses están diseñados para grupos más grandes de tripulación, ofreciendo asientos cómodos y amplio almacenamiento de equipaje.\n\nCon aire acondicionado, asientos reclinables y calidad de viaje suave, estos vehículos aseguran que su tripulación llegue descansada y lista para sus funciones.',

    'fleet_minicoach_title': 'Mini Coach',
    'fleet_minicoach_capacity': 'Capacidad de Pasajeros 1-35',
    'fleet_minicoach_description': 'Nuestros mini coaches premium proporcionan transporte de lujo para grupos grandes de tripulación con máximo confort y estilo.\n\nCon asientos acolchados, sistemas de entretenimiento y control climático, estos coaches ofrecen una experiencia de viaje de primera clase para sus transferencias de tripulación más importantes.',

    // Passenger capacity
    'passenger_capacity': 'Capacidad de Pasajeros',
    'seats': 'asientos',

    // How We Work section
    'how_we_work_title': 'Cómo Trabajamos',
    'how_we_work_description': 'Nuestro compromiso con la excelencia se basa en tres principios fundamentales que impulsan la calidad de nuestro servicio.',
    'how_we_work_card1_title': 'Priorizamos a las Personas',
    'how_we_work_card1_description': 'Nunca hemos tenido un trabajo demasiado pequeño, demasiado grande o demasiado complejo para nosotros; ya sea transportando uno o dos clientes o hasta 35 miembros de tripulación, puede contar con nosotros.',
    'how_we_work_card2_title': 'Conductores Profesionales',
    'how_we_work_card2_description': 'Nuestros conductores tienen licencias profesionales, conocen sus rutas, conducen sus vehículos con la mayor seguridad posible y siempre tratan a nuestros clientes con altos estándares y cortesía.',
    'how_we_work_card3_title': 'Actualizaciones en Tiempo Real',
    'how_we_work_card3_description': 'Airline Crew Transportation ha establecido un eficiente centro de despacho centralizado para gestionar el envío diario de conductores y autobuses. Se ha implementado GPS en tiempo real para garantizar la seguridad de todos los pasajeros.',

    // Contact section
    'contact_title': 'Contáctenos',
    'contact_subtitle': '¿Listo para comenzar? Comuníquese con nosotros hoy y déjenos manejar sus necesidades de transporte.',
    'contact_name': 'Nombre',
    'contact_name_placeholder': 'Su Nombre Completo',
    'contact_name_required': 'El nombre es obligatorio',
    'contact_email': 'Correo Electrónico',
    'contact_email_placeholder': 'su@email.com',
    'contact_email_required': 'El correo electrónico es obligatorio',
    'contact_email_invalid': 'Por favor, introduce una dirección de correo electrónico válida',
    'contact_phone': 'Teléfono',
    'contact_phone_placeholder': 'Su Número de Teléfono',
    'contact_subject': 'Asunto',
    'contact_subject_placeholder': 'Asunto',
    'contact_subject_required': 'El asunto es obligatorio',
    'contact_message': 'Mensaje',
    'contact_message_placeholder': 'Su mensaje',
    'contact_message_required': 'El mensaje es obligatorio',
    'contact_submit': 'Enviar',
    'contact_sending': 'Enviando...',
    'contact_success': '¡Su mensaje ha sido enviado exitosamente!',
    'contact_thank_you': '¡Gracias!',
    'contact_success_message': 'Su mensaje ha sido enviado exitosamente. Nos pondremos en contacto con usted en breve.',
    'contact_send_another': 'Enviar Otro Mensaje',
    'contact_hours': 'Horario',
    'contact_24_7': 'Servicio al Cliente 24/7',

    // Footer
    'footer_copyright': 'Airline Crew Transportation. Todos los Derechos Reservados.',

    // Locations page
    'locations_page_title': 'Nuestras Ubicaciones',
    'locations_page_subtitle': 'Sirviendo a las principales ciudades de todo el mundo con servicios de transporte premium',

    // San Francisco location
    'location_sf_title': 'San Francisco',
    'location_sf_description': 'Es el centro cultural, comercial y financiero del norte de California. La ciudad es uno de los destinos turísticos más populares. También es la sede central de Airline Crew Transportation.',

    // Silicon Valley location
    'location_sv_title': 'Silicon Valley',
    'location_sv_description': 'Es la parte sur del Área de la Bahía de San Francisco. Es el hogar de muchas de las corporaciones tecnológicas más grandes del mundo. Entre ellas están Fortune 1000, Adobe, eBay, Apple, Google, Facebook y Tesla, por nombrar algunas.',

    // Miami location
    'location_miami_title': 'Miami',
    'location_miami_description': 'Miami resplandece durante todo el año con emocionantes lugares de entretenimiento y atracciones. Airline Crew Transportation ha desarrollado una sólida relación laboral con los principales hoteles y alojamientos de Miami, brindando a su tripulación de vuelo y pasajeros de primera clase y clase ejecutiva acceso a lo mejor de Miami.',

    // Los Angeles location
    'location_la_title': 'Los Ángeles',
    'location_la_description': 'Los Ángeles es la segunda ciudad más grande de los EE.UU. y la ciudad más poblada de California. La segunda sucursal de Airline Crew Transportation está convenientemente ubicada en el aeropuerto LAX en Los Ángeles.',

    // New York City location
    'location_nyc_title': 'Nueva York',
    'location_nyc_description': 'Nueva York está clasificada como la ciudad más fotografiada del mundo. Sería un placer tener a su empresa unirse a la creciente lista de clientes satisfechos de Airline Crew Transportation que nos han sido leales a lo largo de los años debido a nuestro excepcional servicio.',

    // Fort Worth location
    'location_fw_title': 'Fort Worth',
    'location_fw_description': 'Fort Worth, una ciudad extensa, vibra con energía y un espíritu independiente. Actualmente hacemos negocios con los tres hoteles principales en Dallas. También transportamos a cuatro aerolíneas principales en el Aeropuerto de Fort Worth.',

    // Sydney location
    'location_sydney_title': 'Sídney, Australia',
    'location_sydney_description': 'Sídney es un destino que nunca olvidarás, una ciudad de atracciones icónicas y playas brillantes. Airline Crew Transportation en Sídney actualmente proporciona servicios de transporte para tripulaciones de vuelo y cabina de importantes aerolíneas y programas de transporte para hoteles en los alojamientos más prestigiosos de Sídney.',
  }
};

export default es; 